import React from 'react';
import { PropTypes } from 'prop-types';
import format from 'date-fns/format';
import common from 'constants/common';
import Activity from './activity';

const DATE_FORMAT = common.dateFormats.full;

const LastActivity = ({ lastActivity }) =>
  lastActivity ? (
    <div className="ccm-activity-row__activity">
      <div className="ccm-activity-row__activity-action">
        <Activity actionType={lastActivity.actionType} />
      </div>
      <div>{format(new Date(lastActivity.createdAt), DATE_FORMAT)}</div>
    </div>
  ) : (
    <span className="ccm-activity-row__activity--no-info">
      This patient has no activity yet
    </span>
  );

LastActivity.propTypes = {
  lastActivity: PropTypes.shape({
    actionGuid: PropTypes.string,
    actionType: PropTypes.string,
    createdAt: PropTypes.string,
    time: PropTypes.number,
  }),
};

export default LastActivity;
